import { useApplicationContext } from 'shared/utils/applicationContext';
import { getInfrastructureRadius } from 'shared/utils/infrastructure';

export const useInfrastructureDistance = () => {
  const { config } = useApplicationContext();

  const radius = getInfrastructureRadius(config);

  return radius / 1000;
};
